import {useContext, useEffect, useState} from "react";
import {ApiContext} from "../../util/Requests";
import EditableAutoCompleteBase from "./EditableAutoCompleteBase";
import UserPreviewModal from "../modals/previews/UserPreviewModal";


const EditableCardEntryUserBase = ({fancy = false, isEditing, onEdit, baseValue, displayLabel = "User", filterFunction = () => true, isMultiSelect = false, showPCID = false}) => {
    const {caches} = useContext(ApiContext);

    const users = caches.users.ref.current;

    if (!users)
        return null;

    // Handle both single and multi-select cases
    let selectedUsers;
    if (isMultiSelect) {
        selectedUsers = (baseValue ? baseValue : []).map(v => users.find(user => user.insiteID == v)).filter(v => v);
    } else {
        selectedUsers = baseValue ? (users.find(user => user.insiteID == baseValue)) ?? {} : {};
    }

    const selectedNames = isMultiSelect 
        ? selectedUsers.map(it => <UserPreviewModal user={it} fancy={fancy} linkContent={it.name}/>)
        : <UserPreviewModal user={selectedUsers} fancy={fancy} linkContent={`${showPCID && selectedUsers.paycomID ? `(${selectedUsers.paycomID}) ` : ''}${selectedUsers.name}`}/>;

    // console.log(selectedNames, selectedUsers, baseValue);

    return <EditableAutoCompleteBase
        label={displayLabel}
        defaultValue={isMultiSelect ? selectedUsers.map(it => it.insiteID) : selectedUsers.name}
        items={users.filter(filterFunction)}
        idKey={"insiteID"}
        nameKey={"name"}
        placeholder={`User Name${isMultiSelect ? 's' : ''}`}
        onSelect={onEdit}
        displayValue={
        isMultiSelect ?
            (selectedUsers.length ?
                selectedNames :
                <i>No Users</i>
            ) :
            (selectedUsers ?
                selectedNames :
                "???"
            )
        }
        cancelButton={!isMultiSelect}
        isEditing={isEditing}
        multiSelect={isMultiSelect}
        onCancel={!isMultiSelect ? () => onEdit(-1) : () => {}}
    />
}

export default EditableCardEntryUserBase;